import { RouteRecordRaw } from 'vue-router'

const shapeArchitect3dRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'shape_architect_3d_dashboard',
        component: () => import('../../components/ShapeArchitect3D/Dashboard.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/project/:id',
        name: 'shape_architect_3d_editor',
        component: () => import('../../components/ShapeArchitect3D/ShapeEditor.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'shape_architect_3d_login',
        component: () => import('../../components/ShapeArchitect3D/Login.vue')
    }
]

export default shapeArchitect3dRoutes
